var SelectBar = function () {
  function SelectBar () {
    this.DOM = {
      tabs: document.getElementsByClassName('select-bar__tab'),
      panels: document.getElementsByClassName('select-bar__panel'),
    };

    this.relevantHashes = [
      'by-size',
      'by-vehicle',
    ];

    this.handleTabs();
    this.listenForHashChange();
  }

  SelectBar.prototype.handleTabs = function () {
    var _this = this;

    for (var i = 0; i < _this.DOM.tabs.length; i++) {
      _this.DOM.tabs[i].addEventListener('click', function (e) {
        if (_this.relevantHashes.includes(e.target.dataset.target)) {
          window.location.hash = '#' + e.target.dataset.target;
        }
      });
    }
  };

  SelectBar.prototype.handlePanels = function () {
    var _this = this;
    var hash = window.location.hash.replace('#', '');

    if (!this.relevantHashes.includes(hash)) {
      return;
    }

    for (var i = 0; i < _this.DOM.panels.length; i++) {
      if (_this.DOM.panels[i].dataset.id === hash) {
        _this.DOM.panels[i].classList.add('active');
      } else {
        _this.DOM.panels[i].classList.remove('active');
      }
    }
  };

  SelectBar.prototype.listenForHashChange = function () {
    var _this = this;
    if (_this.relevantHashes.includes(window.location.hash.replace('#', ''))) {
      _this.handlePanels();
    }

    window.addEventListener('hashchange', function () {
      _this.handlePanels();
    });
  };

  return SelectBar;
}();

document.addEventListener('DOMContentLoaded', function () {
  new SelectBar();
});

